import {MainGrid} from 'components/atoms/Layout/MainGrid';
import {P} from 'components/atoms/Text/P';
import React from 'react';
import {FormattedMessage} from 'react-intl';

import './style.scss';

import {useAuth} from "features/authentication/hooks/useAuth";
import {Headline} from '@atoms/Text/Headline';
import {HeadlineLevel} from 'features/ui/enums';

export const HorizontalUserCard: React.FunctionComponent = () => {

    const {user} = useAuth();

    return (
        <div className="horizontal-user">
            <Headline level={HeadlineLevel.H5}><FormattedMessage id="jm.components.HorizontalUserCard.myContact" /></Headline>
            <P><FormattedMessage id="jm.components.HorizontalUserCard.myContactDescription" /></P>

            <MainGrid fullwidth>
                {user?.firstName &&
                <div className="horizontal-user__user-data">
                    <span className="horizontal-user__user-data-label"><FormattedMessage id="jm.components.HorizontalUserCard.firstname" /></span>
                    <span>{user.firstName}</span>
                </div>
                }

                {user?.lastName &&
                <div className="horizontal-user__user-data">
                    <span className="horizontal-user__user-data-label"><FormattedMessage id="jm.components.HorizontalUserCard.lastname" /></span>
                    <span>{user.lastName}</span>
                </div>
                }

                {user?.email &&
                <div className="horizontal-user__user-data">
                    <span className="horizontal-user__user-data-label"><FormattedMessage id="jm.components.HorizontalUserCard.email" /></span>
                    <span>{user.email}</span>
                </div>
                }

                {user?.phoneNumber &&
                <div className="horizontal-user__user-data">
                    <span className="horizontal-user__user-data-label"><FormattedMessage id="jm.components.HorizontalUserCard.phone" /></span>
                    <span>{user.phoneNumber}</span>
                </div>
                }
            </MainGrid>
        </div>
    )
};
